import { connectWithHammock, ENDPOINTS } from 'hammock';
import React from 'react';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';

import { FormType } from '@candu-ai/forms/types';
import { View } from 'dashboard/components/View';

export interface FormsProps {
  resource: FormType[];
}

export const FormsImpl: React.FC<FormsProps> = ({ resource: formsList }: FormsProps) => {
  return (
    <View titleLvl1="Forms">
      <Helmet title="Form Responses | Candu" />
      <Outlet context={{ items: formsList }} />
    </View>
  );
};

export const Forms = connectWithHammock({
  endpoint: ENDPOINTS.forms,
})(FormsImpl);
